module.exports = __webpack_public_path__ + "static/amit1-c24b79be6291ba35d19336c20a1aa45d.jpg";